import React from 'react';

const Services = () => (
  <div className="Services" id="services">
    <div className="sectionHeading">
      <div className="sectionLeftHeading">
        <h3 className="headingPinked">My services</h3>
        <h2>What I do</h2>
      </div>
      <div className="sectionRightMoreDetails" />
    </div>

    <div className="servicesbody">
      <div className="service">
        <h1>1</h1>
        <h2>Front End Development</h2>
        <p>
          I possess the ability to faithfully reproduce website design mockups and
          seamlessly translate them into fully functional live websites, meticulously
          capturing every intricate detail along the way.
        </p>
      </div>

      <div className="service">
        <h1>2</h1>
        <h2>Back End Development</h2>
        <p>
          I excel at providing the driving force behind your website&apos;s frontend by
          seamlessly integrating it with a tailor-made backend program. This synergy
          ensures your website not only looks impressive but also functions flawlessly.
        </p>
      </div>

      <div className="service">
        <h1>3</h1>
        <h2>Full stack web development</h2>
        <p>
          I offer a comprehensive solution for those seeking a seamless end-to-end project
          execution. With proficiency spanning both frontend and backend domains, I ensure a
          streamlined and cohesive development process, resulting in a polished final product.
        </p>
      </div>

      <div className="service">
        <h1>4</h1>
        <h2>Technical writing</h2>
        <p>
          I derive immense satisfaction from imparting knowledge, skillfully dismantling seemingly
          intricate concepts to present them through easily comprehensible, step-by-step tutorials.
          Feel free to explore a selection of my blog posts to witness this approach in action.
        </p>
      </div>
    </div>
  </div>
);

export default Services;
